<template>
<div>
  <scroll-bar>
    <el-menu 
      mode="vertical"
      :show-timeout="200"
      :default-active="activeIndex"
      :collapse="isCollapse"
      background-color="#fff"
      text-color="black"
      :active-text-color="white"
      @select="handleSelect"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  data(){
    return{
      activeIndex:'',
      white:'#fff'
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    },
  },
  watch:{
      activeIndex(newValue){
        // //console.log(newValue,this.$route.path)
          if(newValue != this.$route.path){
                  this.activeIndex = this.$route.path + '/';
                      // //console.log( this.activeIndex,2)
          }
      },
    
   $route(val){
      if(val.path === '/helpCenter' || val.path ==='/updatePassWord'){
        this.white = '#000'
        // setTimeout(()=>{
        //    //console.log(this.$refs.menuList);
        //   this.$refs.menuList.classList.add('menuList' )},400
        //   )
      }else{
        this.white = '#fff'
      }
    }
  
  },
  mounted(){
    this.activeIndex = sessionStorage.getItem('keyPath') || '/ums-home/';
    // //console.log( this.activeIndex,1)
    // this.handleSelect('/ums-home/')
  },
  methods:{
     handleSelect (index) {
       sessionStorage.setItem('keyPath', index);
      // this.path = index;
      
            
 
    }
  }
}
</script>
<style >
/* .menuList{
  color: black !important;
} */
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue